import type { LocationValue } from "@/react/hooks/useMapbox";
import { SearchableSelect } from "../../SearchableSelect";
import { Typography } from "../../Typography";

export const OptionsList = ({
  locationOptions,
}: {
  locationOptions: LocationValue[];
}) => (
  <>
    {locationOptions.map(option => {
      const { text, value, description } = option;

      return (
        <SearchableSelect.Option key={value} option={option}>
          <div className="text-default flex flex-row items-center gap-2">
            <div className="flex flex-1 flex-col gap-1">
              <Typography.LabelSm weight="medium">{text}</Typography.LabelSm>
              {description && (
                <Typography.LabelXs>
                  <span className="text-light">{description}</span>
                </Typography.LabelXs>
              )}
            </div>
          </div>
        </SearchableSelect.Option>
      );
    })}
  </>
);
